module.exports = __webpack_public_path__ + "static/media/manya.5e33543f.png";